/** Classic stud-brick palette + neon accents from the OnlyBuilds poster */
export const BRICK_COLORS = {
  red: 0xc91a09,
  brightRed: 0xff3b4a,
  orange: 0xfe8a18,
  yellow: 0xf5cd2f,
  green: 0x237841,
  blue: 0x0055bf,
  cyan: 0x00e5ff,
  darkBlue: 0x0a3463,
  black: 0x1b2a34,
  white: 0xf4f4f4,
  lime: 0xbbe90b,
  magenta: 0xc870a0,
} as const;

export type BrickColorName = keyof typeof BRICK_COLORS;

export const PLAY_PALETTE: BrickColorName[] = [
  "red",
  "brightRed",
  "orange",
  "yellow",
  "blue",
  "cyan",
  "green",
  "lime",
];

export function randomPlayColor(): number {
  const name = PLAY_PALETTE[Math.floor(Math.random() * PLAY_PALETTE.length)]!;
  return BRICK_COLORS[name];
}
